import { flattenDeep, findIndex, find } from 'lodash';

import * as constants from './FreeModeBook.constants';
import * as services from './FreeModeBook.service';

export const storeFactory = (constants, services) => {
  const state = {
    Book: {},
    BasisVideos: [],
    ReadyToPlayVideos: [],
    isRequest: false,
  };

  const mutations = {
    [constants.SET_BULLET_STATUS](state, { video, status }) {
      const idx = findIndex(state.ReadyToPlayVideos, (v) => v.videoId == video.videoId);
      state.ReadyToPlayVideos[idx].bulletStatus = status;
      const list = state.Book.readingGroupList;
      for (let i = 0, l = list.length; i < l; i++) {
        const videos = list[i].videos;
        for (let ii = 0, ll = videos.length; ii < ll; ii++) {
          const v = videos[ii];
          if (v.bulletId == video.bulletId && v.videoId == video.videoId) {
            v.bulletStatus = status;
          }
        }
      }
    },

    [constants.FILE_GENERATED_SUCCESS](state, { fileId, filePath }) {
      for (let i = 0, l = state.Book.files.length; i < l; i++) {
        const file = state.Book.files[i];
        if (file.fileId == fileId) {
          file.filePath = filePath;
        }
      }
    },

    [constants.GET_FREE_BOOK_SUCCESS](state, Book) {
      state.Book = Book;
      state.ReadyToPlayVideos = flattenDeep(
        state.Book.readingGroupList
          .map((v) => v.videos)
          .map((v) => {
            if (v.length == 0) {
              return v;
            }
            const last = v.pop();
            last['endOfReading'] = true;
            v.push(last);
            return v;
          })
      ).map((v, i, arr) => {
        return {
          courseId: Book.courseId,
          bookId: Book.bookId,
          bulletName: v.bulletName,
          bulletId: v.bulletId,
          videoId: v.videoId,
          speed1: v.vpath,
          speed1Dot3: v.vpath_1_3,
          speed1Dot5: v.vpath_1_5,
          speed2: v.vpath_2,
          vpathFree: v.vpathFree,
          isLatest: i === arr.length - 1,
          endOfReading: v.endOfReading ? true : false,
          collected: v.collected ? true : false,
          bulletStatus: v.bulletStatus,
          isNew: v.newPath ? true : false,
          lastProgress: v.lastProgress,
          videoSpeed: v.videoSpeed,
          canAccess: v.canAccess,
          liveURL: v.liveURL,
          liveId: v.liveId,
          freeMode: Book.freeMode,
        };
      });
    },

    [constants.SET_IS_REQUEST_STATUS](state, status) {
      state.isRequest = status;
    },

    [constants.ADD_VIDEO_TO_FAVORITE_LIST](state, bulletId) {
      const index = findIndex(state.ReadyToPlayVideos, (v) => v.bulletId === bulletId);
      if (index != -1) {
        const elem = state.ReadyToPlayVideos[index];
        elem.collected = !elem.collected;
      }
    },
  };

  const actions = {
    async getBook({ commit }, payload) {
      commit(constants.SET_IS_REQUEST_STATUS, true);
      const res = await services.getBook(payload);
      commit(constants.GET_FREE_BOOK_SUCCESS, res.data.data);
      commit(constants.SET_IS_REQUEST_STATUS, false);
    },

    async addToFavoriteList({ commit }, payload) {
      const res = await services.addToFavoriteList(payload);
      if (res.data.data) {
        commit(constants.ADD_VIDEO_TO_FAVORITE_LIST, payload.bulletId);
      }
    },

    async generateFile({ commit }, payload) {
      const res = await services.generateFile(payload);
      commit(constants.FILE_GENERATED_SUCCESS, { ...payload, filePath: res.data.data });
    },
  };

  const getters = {
    Book: (state) => state.Book,
    isRequest: (state) => state.isRequest,
    ReadyToPlayVideos: (state) => state.ReadyToPlayVideos.filter((v) => v.canAccess),

    lastTimeReadingBulletId: (state) => {
      const lastTimeReading = find(state.Book.readingGroupList, (reading) => reading.isCurrent);
      if (lastTimeReading) {
        const lastTimeBullet = find(lastTimeReading.videos, (bullet) => bullet.isCurrent);
        if (lastTimeBullet) {
          return {
            readingId: lastTimeReading.readingId,
            bulletId: lastTimeBullet.bulletId,
          };
        }
      }
      return {
        readingId: -1,
        bulletId: -1,
      };
    },
  };

  return {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
};

export default storeFactory(constants, services);
